import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorFundBillSearch = () => {
  const fundBillSearch = useCallback((payload, callback, loading) => {
    ApiService.jsonRequest('/fund-bill/search', payload, response => {
      if (response.status_code === 200) {
        loading(false)
        callback(response.data)
      }
    })
  }, [])
  return { fundBillSearch }
}

export default InteractorFundBillSearch
